export default {
    paymentMethodTitle:"Payment Methods",
    creditCardPaymentMethodExpiryLabel:"Expires {{date}}",
    defaultPaymentMethodLabel:"Default",
    addPaymentMethodActionLabel:"Add Payment Method",
}